import './Pagination.scss';

import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

interface IProps {
  activeIndex: number;
  pageCount: number;
  formatLink: (pageNumber: number) => string;
}

function Pagination({ activeIndex, pageCount, formatLink }: IProps) {
  const renderLink = (type: 'left' | 'right' | 'number', pageIndex: number) => {
    const isArrow = type !== 'number';
    const isDisabled = pageIndex < 0 || pageIndex >= pageCount;
    const pageNumber = pageIndex + 1;

    const key = isArrow ? type : pageIndex;
    const props: HTMLAttributes<any> = {
      children: isArrow ? <i className={`modIcon modIcon--chevron-${type}`} /> : pageNumber,
      className: classNames('modPagination__element', {
        'modPagination__element--arrow': isArrow,
        'modPagination__element--active': pageIndex === activeIndex,
        'modPagination__element--disabled': isDisabled,
      }),
    };

    return isDisabled ? (
      <span key={key} {...props} />
    ) : (
      <Link key={key} {...props} to={formatLink(pageNumber)} />
    );
  };

  return (
    <nav className="modPagination">
      {renderLink('left', activeIndex - 1)}
      {[...Array(pageCount).keys()].map((i) => renderLink('number', i))}
      {renderLink('right', activeIndex + 1)}
    </nav>
  );
}

export default Pagination;
